<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control label="E-mail">
    <input
      [formControl]="form.controls.email"
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control label="Nazwa użytkownika">
    <input
      [formControl]="form.controls.username"
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control label="Imię">
    <input
      [formControl]="form.controls.firstName"
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control label="Nazwisko">
    <input
      [formControl]="form.controls.lastName"
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control label="Wyświetlana nazwa">
    <input
      [formControl]="form.controls.displayName"
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control label="Role użytkownika">
    @if (rolesSelectItems$ | async; as selectItems) {
      <p-multiSelect
        (onClear)="handleClearRolesClick()"
        [fluid]="true"
        [formControl]="form.controls.roles"
        [options]="selectItems"
        appPrimengMultiselect />
    }
  </app-form-control>

  <app-form-control
    inputId="58932b9a-8035-4561-bf71-54d167fa1f43"
    label="Newsletter">
    <app-checkbox-with-label
      inputId="58932b9a-8035-4561-bf71-54d167fa1f43"
      type="short">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.newsletter" />

      <span label>Zapisany do newslettera</span>
    </app-checkbox-with-label>
  </app-form-control>

  <app-form-control label="Hasło użytkownika">
    <div class="flex">
      <p-password
        [fluid]="true"
        [formControl]="form.controls.password"
        appPrimengPassword
        class="mr-3 flex-1" />

      <p-button
        (onClick)="handleGeneratePasswordClick()"
        [text]="true"
        appPrimengButton
        label="Generuj hasło"
        type="button" />
    </div>
  </app-form-control>

  <p-button
    [disabled]="form.invalid"
    appPrimengButton
    label="Zapisz"
    severity="primary"
    type="submit" />
</form>
